module.exports = __webpack_public_path__ + "media/AB_Deutsch_Englisch.2d5b313a.mp3";